import { v4 as uuid } from 'uuid';

/**
 * Creates a random RFC 4122 version 4 UUID.
 * @returns Generated UUID string in canonical format.
 */
export const createUUID = () => {
    return uuid();
}

/**
 * Retrieves the file extension (including the leading dot) from a filename.
 * @param name Source filename to inspect.
 * @returns Extension substring starting with the final dot; returns the full name when no dot exists.
 */
export const fileExt = (name: string) => {
    let index  = name.lastIndexOf(".");
    let ext = name.substring(index)
    return ext;
}

/**
 * Sets the content attribute for all meta tags matching the provided name.
 * @param name Name attribute value used for the selector.
 * @param content Content string assigned to each matching meta tag.
 */
export const updateMetaElement = (name: string, content: string) => {
    let items = document.querySelectorAll('meta[name="' + name + '"]');
    if (items.length > 0) {
        items.forEach(m => m.setAttribute('content', content));
    }
}

/**
 * Sets the content attribute for Open Graph meta tags matching the property suffix.
 * @param name Property suffix appended after `og:` in the selector (e.g., `description`).
 * @param content Content string assigned to each matching Open Graph meta tag.
 */
export const updateOgMetaElement = (name: string, content: string) => {
    let items = document.querySelectorAll('meta[property="og:' + name + '"]');
    if (items.length > 0) {
        items.forEach(m => m.setAttribute('content', content));
    }
}